
































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Toast } from 'vant'; 
@Component({
    components: {},
}) 
export default class changeMbTip extends Vue {
   
    public $refs!: {
       
    };

    show = false;
    isChecked = false;

    @Prop({
        default:''
    })
    type:String;

    async mounted() {
        
    }
    async created() {
    
    }
    showFun(){
        this.show = true;
    }
    closeFun(){
        this.$emit('changeConfirm')
        this.show = false;
    }
    onChange(val){
        if(val){
            if(this.type=='receipt'){
                localStorage.setItem('receiptNotTip','true');
            }else{
                localStorage.setItem('labelNotTip','true');
            }
        }
    }

}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/setting/components/changeMbTip.vue